'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useRef, useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { siteConfig } from '@/config/site';
interface BookingButtonProps {
  season: 'summer' | 'winter';
  currentLocale: string;
  variant?: 'primary' | 'secondary' | 'gradient';
  fullWidth?: boolean;
  size?: 'sm' | 'md' | 'lg';
  gradientClass?: string;
}
export default function BookingButton(t0) {
  const $ = _c(28);
  const {
    season,
    currentLocale,
    variant: t1,
    fullWidth: t2,
    size: t3,
    gradientClass
  } = t0;
  const variant = t1 === undefined ? "primary" : t1;
  const fullWidth = t2 === undefined ? false : t2;
  const size = t3 === undefined ? "md" : t3;
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const t = useTranslations("Header");
  let t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const handleClickOutside = event => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
          setIsOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    };
    t5 = [];
    $[0] = t4;
    $[1] = t5;
  } else {
    t4 = $[0];
    t5 = $[1];
  }
  useEffect(t4, t5);
  let t6;
  if ($[2] !== currentLocale || $[3] !== season) {
    const getReservationLink = () => {
      const linkLocale = currentLocale === "fr" ? "fr" : "en";
      return siteConfig.reservation[season][linkLocale];
    };
    t6 = () => {
      const link = getReservationLink();
      window.open(link, "_blank", "noopener,noreferrer");
      setIsOpen(false);
    };
    $[2] = currentLocale;
    $[3] = season;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const handleReservationClick = t6;
  let t7;
  if ($[5] !== season || $[6] !== t) {
    t7 = season === "winter" ? t("reservationDropdownTitleWinter") : t("reservationDropdownTitleSummer");
    $[5] = season;
    $[6] = t;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const title = t7;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      sm: "px-4 py-2 text-sm",
      md: "px-6 py-3 text-base",
      lg: "px-8 py-4 text-lg"
    };
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const sizeClasses = t8;
  const variantClasses = variant === "gradient" && gradientClass ? `bg-gradient-to-r ${gradientClass} text-white border-2 border-white/20 hover:opacity-90` : variant === "primary" ? "bg-primary text-primary-foreground hover:bg-primary/90" : "bg-secondary text-secondary-foreground hover:bg-secondary/80";
  let t9;
  if ($[9] !== isOpen) {
    t9 = () => setIsOpen(!isOpen);
    $[9] = isOpen;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = `${sizeClasses[size]} ${variantClasses} ${fullWidth ? "w-full" : ""} rounded-lg font-bold shadow-md transition-all duration-300 hover:shadow-xl hover:scale-[1.03]`;
  let t11;
  if ($[11] !== t) {
    t11 = t("reservation");
    $[11] = t;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t) {
    t12 = t("reservation");
    $[13] = t;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t10 || $[16] !== t11 || $[17] !== t12 || $[18] !== t9) {
    t13 = <button onClick={t9} className={t10} aria-label={t11}>{t12}</button>;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
    $[18] = t9;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== handleReservationClick || $[21] !== isOpen || $[22] !== t || $[23] !== title) {
    t14 = isOpen && <div className="absolute left-0 mt-2 w-72 rounded-lg border border-border bg-background shadow-lg overflow-hidden z-50"><div className="p-4 space-y-3"><div className="space-y-1"><h3 className="font-semibold text-sm text-foreground">{title}</h3><p className="text-xs text-muted-foreground">{t("reservationDropdownSubtitle")}</p></div><button onClick={handleReservationClick} className="w-full px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:bg-primary/90 transition-colors">{t("reservationDropdownButton")}</button></div></div>;
    $[20] = handleReservationClick;
    $[21] = isOpen;
    $[22] = t;
    $[23] = title;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t13 || $[26] !== t14) {
    t15 = <div className="relative" ref={dropdownRef}>{t13}{t14}</div>;
    $[25] = t13;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  return t15;
}